import { Pie, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins


export default {
  name: 'pie-chart',
  extends: Pie,
  mixins: [reactiveProp],
  props: ['options'],
  mounted () {
    let options = this.options;
    if (options) {
        options.plugins = {
            labels: {
                position: 'outside',
            },
        }
        options.onClick = function(e, d)  {
            setTimeout(() => {
                this._labels[0].options.position = 'outside';
            }, 100)
        };
    }
    this.renderChart(this.chartData, options)
  }
}